import './loader.css';

const Loader = () => {
    return (
        <div className='container'>
            <div className='loader'>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    );
};

export default Loader;
